<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="projects")
    modal-projects(:form='form', :is-add='isModalAdd', :isVisible="isModalVisible" @closeModal="closeModal")
    modal-purchase-orders(:selectedProjectId="selectedProjectId" :isVisible="isModalPurchaseOrdersVisible" @closeModal="closeModalPurchaseOrders")
    modal-change-orders(:projectId="selectedProjectId" :isVisible="isModalChangeOrderVisible" @submit="setAddChangeOrder" @closeModal="closeModalChangeOrders")
    modal-change-status(:form="selectedProject" :project="selectedProject" :isVisible="isModalChangeStatusVisible" @closeModal="closeModalChangeStatus" @submit="updateStatus" :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.projects') }}:
            span {{ $t('strings.description', {attribute: $t('strings.projects')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="exportRecords")
                    vm-icon(icon="download-outline")
                    slot &nbsp;{{ $t('strings.export') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="projects" )
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
                div
                .d-flex.justify-content-between
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('projects.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('projects.'+ item)")
                    template(slot-scope="{data}")
                      vm-order-by-item(v-for="(item,index) in formattedData" :key="index" :value="item.value" :text="item.text" :direction="item.direction")
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns" )
                  .detail(@click="goProjectDetail(data[indextr])")
                    slot(v-if="column == 'sale_amount' || column == 'price' || column == 'expenses'  || column == 'unbilled' || column == 'sale_cost' || column == 'income' || column == 'utility'")  {{data[indextr][column] | currency }}
                    slot(v-if="column == 'iva'")  {{data[indextr][column]+'%'}}
                    slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column == 'invoiced_income'")  {{data[indextr]['income'] +  data[indextr][column]| currency}}
                    slot(v-if="column != 'status' && column != 'created_at' && column != 'invoiced_income' && column != 'unbilled' && column != 'income' && column != 'income' && column != 'expenses' && column != 'sale_cost' && column != 'utility' && column != 'role' && column != 'sale_amount' && column != 'price'  && column != 'iva' && column != 'purchase_order'") {{data[indextr][column]}}
                    vm-status-indicator(v-if="column == 'purchase_order'" :pulse="true" :color="purchaseOrderColor(data[indextr][column])") {{data[indextr][column] ? 'Asignado' : 'No asignado'}}
                    vm-status-indicator(v-if="column == 'status'" :pulse="true" :color="statusColor(data[indextr][column])") {{data[indextr][column] === 1 ? 'Activo' : 'Finalizado'}}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                  vm-dropdown-menu(style="width: 13rem")
                    vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr])")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.edit') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="showModalPurchaseOrders(data[indextr])")
                      vm-icon(icon="file-text-outline")
                      slot &nbsp;{{ $t('strings.purchase_order') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="showModalChangeOrder(data[indextr])")
                      vm-icon(icon="file-add-outline")
                      slot &nbsp;{{ $t('strings.change_order') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="showModalChangeStatus(data[indextr])")
                      vm-icon(icon="file-add-outline")
                      slot &nbsp;{{ $t('strings.change_status') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalProjects = () => import('@/components/modals/ModalProjects.vue')
const ModalPurchaseOrders = () => import('@/components/modals/ModalPurchaseOrders.vue')
const ModalChangeOrders = () => import('@/components/modals/ModalChangeOrders.vue')
const ModalChangeStatus = () => import('@/components/modals/ModalChangeStatus.vue')

export default {
  name: 'Projects',
  components: {
    ModalImport,
    ModalProjects,
    ModalPurchaseOrders,
    ModalChangeOrders,
    ModalChangeStatus
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    form: {
      name: '',
      customer_id: '',
      location: '',
      country: '',
      price: '',
      iva: '',
      total_price: '',
      file: ''
    },
    isModalChangeOrderVisible: false,
    isModalChangeStatusVisible: false,
    selectedProjectId: null,
    selectedProject: null,
    columns: ['name', 'customer_display', 'price', 'iva', 'sale_amount', 'sale_cost', 'utility', 'income', 'invoiced_income', 'unbilled', 'purchase_order', 'status'],
    columnsOrderBy: ['name', 'status'],
    attributeModal: 'name',
    status: [],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        name: '',
        location: '',
        country: '',
        price: '',
        iva: '',
        total_price: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    isModalVisible: false
  }),
  computed: {
    ...mapGetters(['projects', 'catalog', 'pagination', 'filterParams', 'isModalPurchaseOrdersVisible', 'isModalChangeOrdersVisible'])
  },
  methods: {
    ...mapActions([
      'loadRecords',
      'deleteRecord',

      'exportRecords',
      'applyFilter',
      'clearFilter',
      'setModalPurchaseOrders',

      'changeStatus',
      'addChangeOrder'
    ]),
    editRecord (record) {
      this.form = { ...record, price: parseFloat(record.price).toFixed(2) }
      this.isModalAdd = false
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
      this.form = {}
    },
    closeModalPurchaseOrders () {
      this.isModalPurchaseOrders = false
      this.form = {}
    },
    closeModalChangeOrders () {
      this.isModalChangeOrderVisible = false
    },
    closeModalChangeStatus () {
      this.isModalChangeStatusVisible = false
      this.form = {}
    },
    showModalPurchaseOrders (project) {
      this.selectedProjectId = project.id
      this.setModalPurchaseOrders(true)
    },
    purchaseOrderColor (purchaseOrder) {
      return purchaseOrder ? 'success' : 'primary'
    },
    statusColor (status) {
      return status === 1 ? 'success' : 'warning'
    },
    showModalChangeOrder (project) {
      this.selectedProjectId = project.id
      this.isModalChangeOrderVisible = true
    },
    setAddChangeOrder (form, file) {
      this.addChangeOrder({ id: this.selectedProjectId, file: file, record: form })
    },
    showModalChangeStatus (project) {
      this.isModalAdd = false
      this.selectedProject = { ...project }
      this.isModalChangeStatusVisible = true
    },
    goProjectDetail (project) {
      this.$router.push({ name: 'project-detail', params: { id: project.id, origin: 'projects' } })
    },
    updateStatus (form) {
      this.changeStatus({ ...this.selectedProject, ...form })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
